var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useContext, useEffect, memo, } from 'react';
import { Paper, Box, Grid, DialogContent, Dialog, } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { ENDPOINTS, LOG_LEVELS, SERVICES } from '../constants';
import { axiosClient } from '../axios';
import { UserContext, getAuthHeader } from '../auth';
import { appStyles } from '../App.styles';
import { WorkflowsTitle } from './WorkflowsTitle';
import { WorkflowsGrid } from './WorkflowsGrid';
import { getSampleWorkflows } from './constants';
import { Workflow } from './Workflow';
import { CustomWorkflow } from './CustomWorkflow';
;
export const Workflows = memo(function ({ sendMessage, workflow, setWorkflow, workflowOpen, setWorkflowOpen, sx, }) {
    const { t, i18n } = useTranslation();
    const user = useContext(UserContext);
    const SAMPLE_WORKFLOWS = getSampleWorkflows();
    const [customWorkflows, setCustomWorkflows] = useState([]);
    const [workflows, setWorkflows] = useState([]);
    const [workflowsUpdatedFlag, setWorkflowsUpdatedFlag] = useState(0);
    /**
     * Trigger get workflows
    */
    const updateWorkflowsUpdatedFlag = () => {
        setWorkflowsUpdatedFlag(workflowsUpdatedFlag + 1);
    };
    // Fetch and update document when user credential changed
    useEffect(() => {
        const getWorkflows = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                // Get autheHeader
                const authHeader = yield getAuthHeader(user);
                // Get headers
                const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
                // Call get workflows api
                const res = yield axiosClient.get(`${process.env.SERVER_URL}${ENDPOINTS.WORKFLOW}${ENDPOINTS.GET_WORKFLOWS}`, { headers });
                // Get workflows
                const customWorkflows = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.workflows;
                // Set custom prompt
                setCustomWorkflows([...customWorkflows]);
                // Set prompts
                setWorkflows([...customWorkflows, ...SAMPLE_WORKFLOWS]);
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `Workflows, useEffect, getWorkflows, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.WORKFLOW,
                        userId: user === null || user === void 0 ? void 0 : user.uid,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        userAgent: navigator.userAgent,
                    },
                });
            }
            ;
        });
        try {
            if (user) {
                getWorkflows();
                setWorkflowOpen(false);
            }
        }
        catch (err) {
            axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                level: LOG_LEVELS.ERROR,
                logMessage: `Workflows, useEffect, getWorkflows, ${err.message}`,
                metadata: {
                    env: process.env.ENV,
                    service: SERVICES.WORKFLOW,
                    userId: user === null || user === void 0 ? void 0 : user.uid,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    userAgent: navigator.userAgent,
                },
            });
        }
        ;
    }, [user, i18n.language, workflowsUpdatedFlag]);
    const [CustomWorkflowOpen, setCustomWorkflowOpen] = useState(false);
    return (_jsxs(Box, Object.assign({ sx: {
            height: '100%',
            width: '100%',
        } }, { children: [_jsxs(Paper, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.boxShadow), { justifyContent: 'stretch', alignItems: 'stretch', height: '100%', boxSizing: 'border-box', borderRadius: '1rem', padding: {
                        sm: '1.5rem',
                        xs: '0.5rem',
                    }, width: 'calc(100%)' }) }, { children: [_jsxs(Grid, Object.assign({ container: true, sx: {
                            display: (workflowOpen || CustomWorkflowOpen) ? 'none' : 'flex',
                            height: '100%',
                        } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(WorkflowsTitle, { customWorkflows: customWorkflows, setWorkflowOpen: setWorkflowOpen, setWorkflows: setWorkflows, setWorkflow: setWorkflow, setCustomWorkflowOpen: setCustomWorkflowOpen }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, sx: { height: 'calc(100% - 95px)', overflow: 'auto' } }, { children: _jsx(WorkflowsGrid, { workflows: workflows, setWorkflowOpen: setWorkflowOpen, setWorkflow: setWorkflow, updateWorkflowsUpdatedFlag: updateWorkflowsUpdatedFlag }) }))] })), _jsx(Workflow, { sendMessage: sendMessage, setWorkflowOpen: setWorkflowOpen, workflow: workflow, setWorkflow: setWorkflow, setCustomWorkflowOpen: setCustomWorkflowOpen, sx: { display: workflowOpen ? 'block' : 'none' } })] })), _jsx(Dialog, Object.assign({ open: CustomWorkflowOpen, onClose: () => { setCustomWorkflowOpen(false); }, sx: {
                    '&': {
                        padding: '0.5rem',
                        boxSizing: 'border-box',
                    },
                    '& .MuiDialog-paper': {
                        padding: '0',
                        backgroundColor: 'white.main',
                        borderRadius: '1rem',
                        maxWidth: '1024px',
                        width: '100%',
                        maxHeight: '100%',
                        height: '100%',
                    },
                } }, { children: _jsx(DialogContent, { children: _jsx(CustomWorkflow, { setCustomWorkflowOpen: setCustomWorkflowOpen, workflow: workflow, updateWorkflowsUpdatedFlag: updateWorkflowsUpdatedFlag }) }) }))] })));
});
